module.exports = __webpack_public_path__ + "img/TrackNordic-logo-dark-80h.21750375.png";